// Modal.jsx
import React from 'react';

const Modal = ({ children, isOpen, onClose }) => {
    if (!isOpen) return null;

    // return (
    //     <div
    //         style={{
    //             position: 'fixed',
    //             top: 0,
    //             left: 0,
    //             width: '100%',
    //             height: '100%',
    //             backgroundColor: 'rgba(0, 0, 0, 0.5)',
    //             display: 'flex',
    //             alignItems: 'center',
    //             justifyContent: 'center',
    //             zIndex: 9999,  // <-- 기존 1000에서 9999로 변경
    //         }}
    //         onClick={onClose}
    //     >
    //         <div
    //             style={{
    //                 background: '#fff',
    //                 padding: '20px',
    //                 borderRadius: '8px',
    //                 width: '400px',
    //                 maxWidth: '80%',
    //                 boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    //                 position: 'relative',
    //             }}
    //             onClick={(e) => e.stopPropagation()} // Prevent modal click from closing
    //         >
    //             <button
    //                 onClick={onClose}
    //                 style={{
    //                     position: 'absolute',
    //                     top: '10px',
    //                     right: '10px',
    //                     background: 'none',
    //                     border: 'none',
    //                     fontSize: '16px',
    //                     cursor: 'pointer',
    //                 }}
    //             >
    //                 ✖
    //             </button>
    //             {children}
    //         </div>
    //     </div>
    // );
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.8)', // 어두운 배경
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: '#111', // 검정 배경 (더 진한 느낌)
                    color: '#fff', // 흰색 텍스트
                    padding: '30px',
                    borderRadius: '12px',
                    width: '400px', // 고정된 크기
                    maxWidth: '80%',
                    height: 'auto', // 내용에 따라 높이 자동 조정
                    maxHeight: '80%', // 너무 길어지는 경우 제한
                    overflowY: 'auto', // 내용이 길어질 경우 스크롤
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
                    position: 'relative',
                }}
                onClick={(e) => e.stopPropagation()} // Prevent modal click from closing
            >
                {/* Close Button */}
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        background: 'none',
                        border: 'none',
                        color: '#fff', // 흰색 아이콘
                        fontSize: '20px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        padding: '5px',
                    }}
                >
                    ✖
                </button>

                {/* Modal Content */}
                {children}
            </div>
        </div>
    );
};

export default Modal;

